export default __webpack_public_path__ + "static/media/moot-court-3.ac49a4f6.webp";